import { X } from 'lucide-react'
import ReactPlayer from 'react-player'

interface VideoModeration {
  id: string
  user_id: string
  upload_id: string
  proposed_video_url: string
  status: 'pending' | 'approved' | 'rejected'
  rejection_reason?: string
  reviewed_at?: string
  created_at: string
  updated_at?: string
}

interface VideoPlayerProps {
  video: VideoModeration
  onClose: () => void
}

export function VideoPlayer({ video, onClose }: VideoPlayerProps) {
  return (
    <div className="fixed inset-0 z-50 overflow-y-auto">
      <div className="flex min-h-screen items-center justify-center p-4">
        <div className="fixed inset-0 bg-black bg-opacity-50" onClick={onClose}></div>
        
        <div className="relative bg-white rounded-lg shadow-xl max-w-4xl w-full">
          <div className="flex items-center justify-between p-6 border-b">
            <h2 className="text-lg font-semibold text-gray-900">Video Review</h2>
            <button
              onClick={onClose}
              className="text-gray-400 hover:text-gray-600"
            >
              <X className="h-6 w-6" />
            </button>
          </div>
          
          <div className="p-6">
            <div className="mb-4">
              <div className="grid grid-cols-2 gap-4 text-sm">
                <div>
                  <span className="text-gray-600">User ID:</span>
                  <span className="ml-2 font-mono">{video.user_id}</span>
                </div>
                <div>
                  <span className="text-gray-600">Uploaded:</span>
                  <span className="ml-2">{new Date(video.created_at).toLocaleString()}</span>
                </div>
                <div>
                  <span className="text-gray-600">Status:</span>
                  <span className={`ml-2 font-medium ${
                    video.status === 'pending' ? 'text-yellow-600' :
                    video.status === 'approved' ? 'text-green-600' : 'text-red-600'
                  }`}>
                    {video.status}
                  </span>
                </div>
              </div>
            </div>
            
            <div className="aspect-video bg-gray-100 rounded-lg overflow-hidden">
              <ReactPlayer
                url={`/api/v1/admin/videos/${video.id}/stream`}
                controls
                width="100%"
                height="100%"
                config={{
                  file: {
                    attributes: {
                      controlsList: 'nodownload'
                    }
                  }
                }}
              />
            </div>
            
            {video.rejection_reason && (
              <div className="mt-4 p-4 bg-red-50 border border-red-200 rounded-lg">
                <h3 className="text-sm font-medium text-red-800 mb-2">Rejection Reason</h3>
                <p className="text-sm text-red-700">{video.rejection_reason}</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}
